
import { Purchase } from "@/models/base";
import { PurchaseLedger } from "@/models/base/purchase-ledger";
import { LedgerAccount } from "@/models/ledger-account";
import { LedgerAccountService } from "@/services/ledger-account-service";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import { TranslateResult } from "vue-i18n";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			accounts: [] as LedgerAccount[],
			inputs: {
				code: "",
				amount: 0,
				vatPercent: 0,
				comment: ""
			},
		};
	},
	props: {
		value: {
			type: Object as ()=>PurchaseLedger,
			required: true
		},
		purchase: {
			type: Object as ()=>Purchase,
			required: true
		},
	},
	computed: {
		selectedAccount():LedgerAccount {
			let account = this.accounts.find(c=>c.Code == this.inputs.code);
			if (!account) {
				account = this.accounts[0];
				if (!account) {
					account = new LedgerAccount();
				}
			}
			return account;
		},
		vatField():string | TranslateResult{
			if (this.selectedAccount.VatField == 0){
				return this.$ct("common.none");
			}
			return `${this.selectedAccount.VatField}`;
		},
		showRemoveButton(): boolean {
			return this.purchase.Ledgers.indexOf(this.value) != -1;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.inputs.code = this.value.LedgerCode;
				this.inputs.amount = this.value.Amount;
				this.inputs.vatPercent = this.value.VatPercent;
				this.inputs.comment = this.value.Comment;
			}
		},
		inputs: {
			deep: true,
			handler(){
				this.validate();
			}
		}
	},
	methods: {
		validate(){
			this.isValid = true;
			if (this.inputs.code == "") {
				this.isValid = false;
			}
			if (this.inputs.code.indexOf(".") != -1) {
				this.isValid = false;
			}
		},
		submit(){
			this.validate();
			if (!this.isValid) return;
			let ledger = new PurchaseLedger();
			ledger.LedgerCode = this.inputs.code;
			ledger.Amount = this.inputs.amount;
			ledger.VatPercent = this.inputs.vatPercent;
			ledger.Comment = this.inputs.comment;
			ledger.LedgerAccount = this.accounts.find(l=>l.Code == ledger.LedgerCode) || null;
			this.$emit("input", ledger);
		},
		remove(){
			this.$emit("remove");
		}
	},
	async created(){
		this.accounts = (await LedgerAccountService.fetchLedgerAccounts()).filter(a=>!a.isGroup());
		//this.inputs.code = this.accounts[0].Code;
	},
	components: {
		AppLedgerAccountAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
